import React, { useState, useEffect } from "react";
import { Layout, Select, Image, Alert, Tooltip, DatePicker, Space, Button, Card } from "antd";
import CardMonitor from "../../components/dashboard/CardMonitor";
import MobilePatrolDashboard from "../../components/mobile/MobilePatrolDashboard";
import {
  AimOutlined,
  CheckCircleOutlined,
  ExclamationOutlined,
  CloudDownloadOutlined,
  BookOutlined,
  FilterOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import CountUp from "react-countup";
// import MapMonitor from "../../components/dashboard/MapMonitor";
import MapDemo from "../../components/dashboard/MapDemoo";
import { getGeoService } from "../../services/geolocation";
import {
  getPatrolService,
  getPatrolFilterTodayService,
  getPatrolFilterAbnormalTodayService,
} from "../../services/dashboard";

import { getCheckpointReportBySiteService } from "../../services/checkpoint";
import CheckPointList from "../../components/dashboard/CheckPointList";
import Download from "../../components/Download";

const { Content: AntdContent } = Layout;
const { RangePicker } = DatePicker;

const ContentComp = ({ colorBgContainer, borderRadiusLG }) => {
  const formatter = (value) => <CountUp end={value} separator="," />;
  const [geo, setGeo] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  // Mobile detection
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  const [mode, setMode] = useState("1");
  const [patrolCheck, setPatrolCheck] = useState([]);
  const [patrolNormal, setPatrolNormal] = useState([]);
  const [patrolAbnormal, setPatrolAbnormal] = useState([]);
  const [report, setReport] = useState([]);
  const [dateRange, setDateRange] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isAutoUpdate, setIsAutoUpdate] = useState(true);

  const generateKeywordCounts = (cls) => {
    const keywordCounts = {};
    cls?.forEach((keyword) => {
      keywordCounts[keyword] = (keywordCounts[keyword] || 0) + 1;
    });

    return (
      <div className="ml-4">
        Detection:
        {Object.entries(keywordCounts)?.map(
          ([keyword, count]) => ` ${count}x${keyword} `
        )}
      </div>
    );
  };

  // ฟังก์ชันสำหรับการกรองข้อมูลตามช่วงวันที่
  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
    setError(null); // ล้าง error เมื่อมีการเปลี่ยนแปลง dateRange
    
    // อัปเดตสถานะ auto update
    if (dates && dates[0] && dates[1]) {
      setIsAutoUpdate(false);
    } else {
      setIsAutoUpdate(true);
    }
  };

  // ฟังก์ชันสำหรับจัดการ error โดยไม่ให้ทับซ้อน
  const handleError = (errorMessage) => {
    if (!error) {
      setError(errorMessage);
    }
  };

  // ฟังก์ชันสำหรับรีเซ็ต filter
  const handleResetFilter = () => {
    setDateRange(null);
    setError(null); // ล้าง error เมื่อรีเซ็ต filter
    setIsAutoUpdate(true); // เปิดการอัปเดตอัตโนมัติเมื่อรีเซ็ต
  };

  // ฟังก์ชันสำหรับการกรองข้อมูลทันทีเมื่อเลือกวันที่
  const handleApplyFilter = () => {
    if (dateRange && dateRange[0] && dateRange[1]) {
      setError(null); // ล้าง error เมื่อเริ่มกรองข้อมูล
      setIsAutoUpdate(false); // ปิดการอัปเดตอัตโนมัติเมื่อกรองข้อมูล
      // ข้อมูลจะถูกอัปเดตอัตโนมัติผ่าน useEffect
      console.log("Applying filter for date range:", dateRange[0].format('YYYY-MM-DD'), "to", dateRange[1].format('YYYY-MM-DD'));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // ถ้ามี dateRange ให้ใช้ dateRange ในการกรอง
        let startDate = null;
        let endDate = null;
        
        if (dateRange && dateRange[0] && dateRange[1]) {
          startDate = dateRange[0].format('YYYY-MM-DD');
          endDate = dateRange[1].format('YYYY-MM-DD');
        }
        
        const result = await getGeoService(
          JSON.parse(localStorage.getItem("site")),
          startDate,
          endDate
        );
        if (result !== null) {
          if (result.length === 0) {
            setGeo([]);
          } else {
            setGeo(result);
          }
        } else {
          handleError("เกิดข้อผิดพลาดในการโหลดข้อมูลตำแหน่ง");
        }
      } catch (error) {
        console.error("Error fetching geo data:", error);
        setError("เกิดข้อผิดพลาดในการโหลดข้อมูลตำแหน่ง");
      } finally {
        setLoading(false);
      }
    };
    
    const fetchCheckpointReport = async () => {
      setLoading(true);
      try {
        // ถ้ามี dateRange ให้ใช้ dateRange ในการกรอง
        let startDate = null;
        let endDate = null;
        
        if (dateRange && dateRange[0] && dateRange[1]) {
          startDate = dateRange[0].format('YYYY-MM-DD');
          endDate = dateRange[1].format('YYYY-MM-DD');
        }
        
        const result = await getCheckpointReportBySiteService(
          JSON.parse(localStorage.getItem("site")),
          startDate,
          endDate
        );
        if (result !== null) {
          if (result.length === 0) {
            setReport([]);
          } else {
            setReport(result);
          }
        } else {
          handleError("เกิดข้อผิดพลาดในการโหลดรายงานการตรวจตรา");
        }
      } catch (error) {
        console.error("Error fetching checkpoint report:", error);
        setError("เกิดข้อผิดพลาดในการโหลดรายงานการตรวจตรา");
      } finally {
        setLoading(false);
      }
    };

    fetchCheckpointReport();
    fetchData();
    
    // ตั้ง interval เฉพาะเมื่อไม่มี dateRange (ไม่มีการกรอง)
    let interval;
    if (!dateRange || !dateRange[0] || !dateRange[1]) {
      setIsAutoUpdate(true);
      interval = setInterval(() => {
        fetchCheckpointReport();
        fetchData();
      }, 15 * 1000);
    } else {
      setIsAutoUpdate(false);
    }
    
    // Cleanup interval เมื่อ component unmount
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [localStorage.getItem("site"), dateRange]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // ถ้ามี dateRange ให้ใช้ dateRange ในการกรอง
        let startDate = null;
        let endDate = null;
        
        if (dateRange && dateRange[0] && dateRange[1]) {
          startDate = dateRange[0].format('YYYY-MM-DD');
          endDate = dateRange[1].format('YYYY-MM-DD');
        }
        
        const result = await getPatrolService(
          JSON.parse(localStorage.getItem("site")),
          startDate,
          endDate
        );
        if (result !== null) {
          setPatrolCheck(result);
        } else {
          handleError("เกิดข้อผิดพลาดในการโหลดข้อมูลการตรวจตรา");
        }

        const resultNormal = await getPatrolFilterTodayService(
          JSON.parse(localStorage.getItem("site")),
          "normal",
          startDate,
          endDate
        );
        if (resultNormal !== null) {
          setPatrolNormal(resultNormal);
        } else {
          handleError("เกิดข้อผิดพลาดในการโหลดข้อมูลเหตุการณ์ทั่วไป");
        }

        const resultAbnormal = await getPatrolFilterAbnormalTodayService(
          JSON.parse(localStorage.getItem("site")),
          "abnormal",
          startDate,
          endDate
        );
        if (resultAbnormal !== null) {
          setPatrolAbnormal(resultAbnormal);
        } else {
          handleError("เกิดข้อผิดพลาดในการโหลดข้อมูลเหตุการณ์ผิดปกติ");
        }
      } catch (error) {
        console.error("Error in fetchData:", error);
        setError("เกิดข้อผิดพลาดในการโหลดข้อมูลการตรวจตรา");
      } finally {
        setLoading(false);
      }
    };
    
    // เรียกใช้ fetchData ทันที
    fetchData();
    
    // ตั้ง interval เฉพาะเมื่อไม่มี dateRange (ไม่มีการกรอง)
    let interval;
    if (!dateRange || !dateRange[0] || !dateRange[1]) {
      setIsAutoUpdate(true);
      interval = setInterval(() => {
        fetchData();
      }, 15 * 1000);
    } else {
      setIsAutoUpdate(false);
    }
    
    // Cleanup interval เมื่อ component unmount
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [localStorage.getItem("site"), dateRange]);

  return (
    <AntdContent
      style={{
        margin: isMobile ? "0" : "24px 16px",
        padding: isMobile ? 0 : 24,
        minHeight: 360,
        background: isMobile ? "transparent" : colorBgContainer,
        borderRadius: isMobile ? 0 : borderRadiusLG,
      }}
    >
      {isMobile ? (
        <MobilePatrolDashboard 
          patrolCheck={patrolCheck}
          patrolNormal={patrolNormal}
          patrolAbnormal={patrolAbnormal}
          report={report}
          loading={loading}
          onRefresh={async () => {
            // Trigger refresh for mobile
            window.location.reload();
          }}
        />
      ) : (
        <>
          {/* Filter Section */}
          <Card 
            className="mb-2 md:mb-4" 
            title={
              <div className="flex items-center text-sm md:text-base">
                <FilterOutlined className="mr-1 md:mr-2" />
                กรองข้อมูลตามช่วงวันที่
              </div>
            }
            extra={
              window.innerWidth >= 768 ? (
                <Space>
                  <RangePicker
                    value={dateRange}
                    onChange={handleDateRangeChange}
                    format="DD/MM/YYYY"
                    placeholder={['วันที่เริ่มต้น', 'วันที่สิ้นสุด']}
                    allowClear={false}
                  />
                  <Button 
                    type="primary"
                    onClick={handleApplyFilter}
                    disabled={!dateRange || !dateRange[0] || !dateRange[1]}
                    loading={loading}
                  >
                    กรองข้อมูล
                  </Button>
                  <Button 
                    icon={<ReloadOutlined />} 
                    onClick={handleResetFilter}
                    disabled={!dateRange}
                  >
                    รีเซ็ต
                  </Button>
                </Space>
              ) : null
            }
          >
        <div className="text-gray-600">
          {error ? (
            <span className="text-red-600">
              ⚠️ {error}
            </span>
          ) : loading ? (
            <span className="text-blue-600">
              <ReloadOutlined spin className="mr-1" />
              กำลังโหลดข้อมูล...
            </span>
          ) : dateRange && dateRange[0] && dateRange[1] ? (
            <span>
              แสดงข้อมูลตั้งแต่: <strong className="text-green-600">{dateRange[0]?.format('DD/MM/YYYY')}</strong> 
              ถึง: <strong className="text-green-600">{dateRange[1]?.format('DD/MM/YYYY')}</strong>
              <span className="ml-2 text-xs text-gray-500">(ข้อมูลถูกกรองแล้ว - ไม่มีการอัปเดตอัตโนมัติ)</span>
            </span>
          ) : (
            <span>
              แสดงข้อมูลทั้งหมด (ไม่จำกัดวัน)
              <span className="ml-2 text-xs text-blue-500">
                {isAutoUpdate ? "(ข้อมูลจะอัปเดตอัตโนมัติทุก 15 วินาที)" : "(ไม่มีการอัปเดตอัตโนมัติ)"}
              </span>
            </span>
          )}
        </div>
        
        {/* Mobile filter controls */}
        {window.innerWidth < 768 && (
          <div className="mb-3 space-y-2">
            <RangePicker
              value={dateRange}
              onChange={handleDateRangeChange}
              format="DD/MM/YYYY"
              placeholder={['วันที่เริ่มต้น', 'วันที่สิ้นสุด']}
              allowClear={false}
              size="small"
              className="w-full"
            />
            <div className="flex space-x-2">
              <Button 
                type="primary"
                onClick={handleApplyFilter}
                disabled={!dateRange || !dateRange[0] || !dateRange[1]}
                loading={loading}
                size="small"
                className="flex-1"
              >
                กรองข้อมูล
              </Button>
              <Button 
                icon={<ReloadOutlined />} 
                onClick={handleResetFilter}
                disabled={!dateRange}
                size="small"
              >
                รีเซ็ต
              </Button>
            </div>
          </div>
        )}
      </Card>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3">
        <CardMonitor
          title={<div>จำนวนจุด check-in (ครั้ง)</div>}
          color={"#FFC13F"}
          icon={
            <Tooltip title={"ข้อมูลนี้คือจำนวนทั้งหมดตั้งแต่เริ่มต้นหน่วยงาน"}>
              <AimOutlined />
            </Tooltip>
          }
          description={
            <div className="text-[28px]">
              {loading ? (
                <div className="animate-pulse">กำลังโหลด...</div>
              ) : (
                patrolCheck.length == 1000
                  ? "1000+"
                  : formatter(patrolCheck.length)
              )}
            </div>
          }
          actions={
            <CheckPointList title={"รายงานจุด check-in"} data={patrolCheck} />
          }
        />
        <CardMonitor
          title={
            <div className="flex items-center justify-between">
              <div>จำนวนเหตุการณ์ทั่วไป (ครั้ง)</div>
              <div className="w-8 h-8 flex items-center justify-center rounded-[6px] text-black text-[24px]">
                <Download
                  tip={"โหลดรายงานเหตุการณ์ทั่วไป"}
                  icon={<CloudDownloadOutlined />}
                  status={"normal"}
                />
              </div>
            </div>
          }
          color={"#008000"}
          icon={<CheckCircleOutlined />}
          description={
            <div className="text-[28px]">
              {loading ? (
                <div className="animate-pulse">กำลังโหลด...</div>
              ) : (
                formatter(patrolNormal.length || 0)
              )}
            </div>
          }
          actions={
            <CheckPointList
              title={"รายงานเหตุการณ์ทั่วไป"}
              data={patrolNormal}
            />
          }
        />
        <CardMonitor
          title={
            <div className="flex items-center justify-between">
              <div>จำนวนเหตุการณ์ผิดปกติ (ครั้ง)</div>
              <div className="w-8 h-8 flex items-center justify-center rounded-[6px] text-black text-[24px]">
                <Download
                  tip={"โหลดรายงานเหตุการณ์ผิดปกติ"}
                  icon={<CloudDownloadOutlined />}
                  status={"abnormal"}
                />
              </div>
            </div>
          }
          color={"#FF0000"}
          icon={<ExclamationOutlined />}
          description={
            <div className="text-[28px]">
              {loading ? (
                <div className="animate-pulse">กำลังโหลด...</div>
              ) : (
                formatter(patrolAbnormal.length || 0)
              )}
            </div>
          }
          actions={
            <CheckPointList
              title={"รายงานเหตุการณ์ผิดปกติ"}
              data={patrolAbnormal}
            />
          }
        />
      </div>
          <div className="mt-2 md:mt-4 grid grid-cols-1 lg:grid-cols-3 gap-2 md:gap-4">
        <CardMonitor
          color={"#FF0000"}
          icon={<ExclamationOutlined />}
          title={
            <div className="flex justify-between">
              <div>รายงานเหตุการณ์ผิดปกติ</div>
            </div>
          }
          actions={
            <div className="overflow-y-scroll max-h-[410px] space-y-2 text-left">
              {patrolAbnormal?.map((item, index) => (
                <div key={index}>
                  <Alert
                    style={{ width: "28vw" }}
                    message={<div className="ml-4">{item.report_name}</div>}
                    description={
                      <>
                        <div className="ml-4">
                          <p className="font-bold mb-0">บันทึกข้อความ:</p>{" "}
                          {item.report_message.includes("\n")
                            ? item.report_message
                              .split("\n")
                              .slice(1, -1)
                              ?.map((item, index) => (
                                <div key={index}>{item}</div>
                              ))
                            : item.report_message}
                        </div>
                        <div className="ml-4">{`VisionLLM: ${item.llm || ""
                          }`}</div>
                        {generateKeywordCounts(item.cls)}
                      </>
                    }
                    type="error"
                    icon={
                      <Image
                        width={100}
                        src={`https://woeexpeqouhtojnuyueg.supabase.co/storage/v1/object/public/${item.report_img[0]}`}
                      />
                    }
                    showIcon
                    closable
                  />
                </div>
              ))}
            </div>
          }
        />

        <CardMonitor
          color={"black"}
          icon={<BookOutlined />}
          title={
            <div className="flex justify-between">
              <div>รายงานการตรวจตรา</div>
            </div>
          }
          actions={
            <div className="overflow-y-scroll max-h-[410px] space-y-2 text-left">
              {report?.map((item, index) => (
                <div key={index}>
                  <Alert
                    style={{ width: "28vw" }}
                    message={<div className="ml-4">{item.employee_name}</div>}
                    description={
                      <>
                        <div className="ml-4">
                          <p className="font-bold mb-0">บันทึกข้อความ:</p>{" "}
                          {item.metadata.split("\n").map((item, index) => (
                            <div key={index}>{item}</div>
                          ))}
                        </div>
                      </>
                    }
                    type="success"
                    icon={
                      <div className="flex flex-col space-y-4">
                        <Image
                          width={100}
                          src={`https://woeexpeqouhtojnuyueg.supabase.co/storage/v1/object/public/siamai/${item.map_image}`}
                        />
                        {item.employee_image && (
                          <Image
                            width={100}
                            src={`https://woeexpeqouhtojnuyueg.supabase.co/storage/v1/object/public/siamai/${item.employee_image}`}
                          />
                        )}
                      </div>
                    }
                    showIcon
                    closable
                  />
                </div>
              ))}
            </div>
          }
        />
        <CardMonitor
          className="col-span-2"
          title={
            <div className="flex justify-between">
              <div>แผนที่การตรวจตรา</div>
              <div>
                <Select
                  className="ml-4"
                  showSearch
                  style={{ width: 200 }}
                  placeholder="ตำแหน่งล่าสุด"
                  onChange={(value) => setMode(value)}
                  value={mode}
                  options={[
                    { value: "1", label: "ตำแหน่งล่าสุด" },
                    { value: "2", label: "เส้นทางการตรวจตรา" },
                    { value: "3", label: "ความถี่การตรวจตรา" },
                  ]}
                />
              </div>
            </div>
          }
          actions={
            <div className="w-[100vw]">
              <MapDemo mode={mode} now={geo} />
            </div>
          }
        />
      </div>
        </>
      )}
    </AntdContent>
  );
};

export default ContentComp;
